import { render, staticRenderFns } from "./data-abstract-unit.vue?vue&type=template&id=20374cd0&scoped=true"
import script from "./data-abstract-unit.vue?vue&type=script&lang=js"
export * from "./data-abstract-unit.vue?vue&type=script&lang=js"
import style0 from "./data-abstract-unit.vue?vue&type=style&index=0&id=20374cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20374cd0",
  null
  
)

export default component.exports